import React from 'react'
import { Accordion, AccordionDetails, AccordionSummary, Button, Card, CardContent, ClickAwayListener, Divider, Grid, Grow, ListItemIcon, ListItemText, MenuItem, MenuList, Paper, Popper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@material-ui/core';
import { useStyles } from './styles'
import 'react-toastify/dist/ReactToastify.css'
import { FaEdit } from 'react-icons/fa';
import { Link } from 'react-router-dom';

function ArticlesTableBody(props: any) {
    const classes = useStyles();

    return (
        <>
            <TableRow>
                <TableCell className={classes.tableCell}>{props.i + 1}</TableCell>
                <TableCell className={classes.tableCell}>{props.roomData?.title}</TableCell>
                <TableCell className={classes.tableCell}>
                    <span
                    style={{
                        color: props.roomData?.status == "published" ? "green" : "black",
                        textTransform: "capitalize"
                    }}
                    >{props.roomData?.status}</span>
                </TableCell>
                <TableCell className={classes.tableCell}>
                    <Link
                        to={"/dashboard/articles/edit/" + props.roomData?._id}>
                        <FaEdit />
                    </Link>
                </TableCell>
            </TableRow>
        </>
    )
}

export default ArticlesTableBody